<template>
  <div class="hideOnScroll filter" ref="hideOnScroll">
    <p-vue-input-text
      type="text"
      class="phone-number search"
      v-model="search"
      :placeholder="__('Search by recipient name or phone number')"
    />
    <a href="#" @click.prevent="filterModal = true">
      <i-icon name="filter" />
    </a>
  </div>

  <div class="items-list">
    <local-key-or-mail-item
      v-for="(item, index) of items"
      :key="index"
      :item="item"
      @editItem="editItem(item)"
      @collection="collection(item)"
    ></local-key-or-mail-item>
    <!-- @showItemData="showItemData"
      @DeleteItem="DeleteItem" -->
  </div>

  <!-- הוספה או עריכה -->
  <i-override-dialog
    v-model:visible="showAddModal"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="isKey ? __('Save key') : __('Save shipping')"
    :fnClose="closeModals"
  >
    <local-add
      :item="itemToEdit"
      :close="closeModals"
      :openedInDialog="true"
      :isEdit="isEdit"
      :IsKey="isKey"
    ></local-add>
  </i-override-dialog>

  <!-- איסוף -->
  <i-override-dialog
    v-model:visible="showCollectionModal"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="isKey ? __('Collection Key') : __('Collection Item')"
    :fnClose="closeModals"
  >
    <local-collection
      :item="itemToEdit"
      :close="closeModals"
    ></local-collection>
  </i-override-dialog>

  <i-plus-button @click="showAddModal = true" />

  <!-- סינונים -->
  <p-vue-sidebar
    position="left"
    class="sidebar--menu"
    id="apartments-and-tenants-filter"
    :style="{
      padding: 0,
      maxWidth: '275px',
    }"
    v-model:visible="filterModal"
  >
    <local-filter
      :filterSelected="filterSelected"
      :filterOptions="filterOptions"
      @filter="filterItems"
      :close="() => (filterModal = false)"
      :isKey="isKey"
    />
  </p-vue-sidebar>
</template>

<script>
import { errorReceived } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import LocalKeyOrMailItem from "./key-or-mail-item";
import LocalAdd from "./add";
import LocalCollection from "./collection";
import LocalFilter from "./filter";

export default {
  components: {
    LocalKeyOrMailItem,
    LocalAdd,
    LocalCollection,
    LocalFilter,
  },
  data() {
    return {
      isKey: false,
      itemsList: [],
      showAddModal: false,
      showCollectionModal: false,
      isEdit: false,
      itemToEdit: {},
      filterModal: false,
      search: "",
      filterOptions: {},
      filterSelected: {},
    };
  },
  mounted() {
    if (this.$route.name == "Keys") this.isKey = true;

    this.getItemsAndFilterData();
  },
  methods: {
    getItemsAndFilterData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("iskey", !!this.isKey, apiPType.Int),
      ];
      callProc("WorkerApp_ItemsOrKeysListAndFilterData", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.itemsList = result.Table;
          // console.log(result);
          this.itemsList.map((item) => {
            item.show = true;
            item.Images = result.Table3.filter((f) => f.itemID == item.ID);
          });
          this.filterOptions.Types = result.Table1;
          this.filterOptions.Buildings = result.Table2;
          this.filterOptions.StorageLocations = [
            ...new Set(result.Table.map((obj) => obj.StorageLocation)),
          ];
          // console.log(this.items.length);
          // if (this.itemsList.length == 1) this.itemsList[0].showData = true;
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_ItemsOrKeysListAndFilterData");
        });
    },
    editItem(item) {
      this.isEdit = true;
      this.itemToEdit = item;
      this.showAddModal = true;
    },
    closeModals() {
      this.isEdit = false;
      this.itemToEdit = {};
      this.showAddModal = false;
      this.showCollectionModal = false;
      this.getItemsAndFilterData();
    },
    collection(item) {
      // console.log(item);
      this.itemToEdit = item;
      this.showCollectionModal = true;
    },
    filterItems(event) {
      this.filterSelected = event;
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
    items() {
      this.itemsList.map((s) => {
        s.show = false;
        if (
          ((this.search &&
            this.search != "" &&
            (s.NameTo?.includes(this.search) ||
              s.PhoneTo?.includes(this.search))) ||
            !this.search ||
            this.search == "") &&
          (s.BID == this.filterSelected.Building?.BID ||
            !this.filterSelected.Building) &&
          (s.StorageLocation == this.filterSelected.StorageLocation ||
            !this.filterSelected.StorageLocation) &&
          (s.Type == this.filterSelected.Type?.Name ||
            !this.filterSelected.Type) &&
          ((this.filterSelected.IsDelivered && s.IsDelivered) || !s.IsDelivered)
        )
          s.show = true;
      });
      return this.itemsList.filter((item) => item.show == true);
    },
  },
};
</script>

<style scoped>
.filter {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px 5px;
  background-color: var(--color-primary);
}

.filter a {
  color: white;
  margin-right: 3px;
}

.filter a:deep(.svg) {
  width: 24px;
  height: 24px;
}

.search {
  flex: 1;

  padding: 0 0 8px 0;

  border-radius: 0;
  border: 1px solid white;
  border-width: 0 0 1px 0;
  background-color: transparent;

  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.search::placeholder {
  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.no-data {
  text-align: center;
  color: var(--color-success);
}

.items-list {
  overflow-y: scroll;
  height: calc(100vh - 155px);
}
</style>
